<template>
  <section class="container">
    <div class="header"
      :style="{backgroundImage:'url(' + require('@/assets/payment-related/payment1564@2x.png') + ')'}">
      <div class="header__info">
        <span class="header__info__title">{{
          $enumObject.providerConfig[config.projectName].provider.providerName
        }}</span>
        <span class="header__info__content">-{{
            $enumObject.providerConfig[config.projectName].provider.propagandaInfo
          }}-</span>
      </div>
    </div>
    <h3 class="prompt_tips">请输入车牌号查询费用</h3>
    <van-radio-group style="justify-content: center" v-model="largeCar" direction="horizontal">
      <van-radio style="font-size:14px" icon-size="18px" :name="false">蓝牌车</van-radio>
      <van-radio style="font-size:14px" icon-size="18px" :name="true">黄牌车</van-radio>
    </van-radio-group>
    <div class="page page-index">
      <keyboard :plateNumber.sync="plateNumber" @change="change"></keyboard>
    </div>

    <div class="btn_box">
      <van-button @click="submit" size="large" class="blue-btn">
        查询订单
      </van-button>
    </div>
    <div v-if="imgBtn.jumpURL" style="margin:10px 0 10px;padding:0 5px 0;background-color:#fff;">
      <a :href="imgBtn?imgBtn.jumpURL:''">
        <van-image width="100%" height="auto" :key="index" :src="imgBtn?imgBtn.imageURL:''" />
      </a>
    </div>
    <div v-if="jntcImg.jumpURL" style="margin:10px 0 10px;padding:0 5px 0;background-color:#fff;">
      <a :href="jntcImg?jntcImg.jumpURL:''">
        <van-image width="100%" height="auto" :key="index" :src="jntcImg?jntcImg.imageURL:''" />
      </a>
    </div>

  </section>
</template>

<script>
import { RadioGroup, Radio } from 'vant'
import keyboard from '@/components/keyboard/index'
import { getUrlParam } from '@/utils'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Pay-Parking-Cost',
  components: {
    keyboard,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  data () {
    return {
      config, //全局项目配置信息
      plateNumber: [],
      largeCar: false,
    }
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token', 'jntcImg', 'imgBtn'])
  },
  methods: {
    change (val) {
      this.plateNumber = val
    },
    submit () {
      let _this = this;
      if (!_this.plateNumber.join('')) {
        _this.$toast('请输入车牌号！')
        return
      }
      let result = true;
      const xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DABCEFGHJK]$)|([DABCEFGHJK][A-HJ-NP-Z0-9][0-9]{4}$))/;
      const creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
      if (_this.plateNumber.join('').length == 7) {
        result = creg.test(_this.plateNumber.join(''));
      } else if (_this.plateNumber.join('').length == 8) {
        result = xreg.test(_this.plateNumber.join(''));
      } else {
        result = false;
      }
      if (!result) {
        _this.$toast('请输入正确的车牌号！')
        return
      }
      let params = {
        cardNumber: _this.plateNumber.join(''),
        largeCar: _this.largeCar,
        parkId: getUrlParam('parkId'),
        type: Number(_this.$route.query.type) || _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType

      }
      this.$store.commit('transaction/SET_BILL_PARAMS', params)
      this.$router.push({
        name: 'Temporary-Parking-Cost',
        query: {
          cardNumber: window.encodeURI(_this.plateNumber.join('')),
          largeCar: _this.largeCar,
          parkId: getUrlParam('parkId'),
          type: Number(_this.$route.query.type) || _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType

        }
      })
    }
  },

}
</script>

<style lang="scss" scoped>
.container {
  .header {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: px2rem(140);
    min-height: px2rem(140);
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &__info {
      width: 70%;
      height: 50%;
      display: flex;
      flex-direction: colunm;
      flex-wrap: wrap;
      align-items: center;

      span {
        color: #fff;
        text-align: center;
      }

      &__title {
        width: 100%;
        font-size: 22px;
        font-weight: 500;
      }

      &__content {
        width: 100%;
        font-size: 18px;
      }
    }
  }

  .prompt_tips {
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;
  }

  .page {
    padding: px2rem(15);
    margin: px2rem(10) 0 px2rem(20);
  }

  .btn_box {
    padding: 0 15px;
  }
}
</style>